import type { Instructor } from '@/types';

/** A few imported records carry a blank first or last name; guard against
 *  producing "undefined" instead of initials. */
export const instrInitials = (i: Partial<Instructor>) => {
  const a = (i.EnglishFirstName || '').trim()[0] ?? '';
  const b = (i.EnglishLastName || '').trim()[0] ?? '';
  return (a + b).toUpperCase() || '?';
};

/** Photo when the record has one, initials otherwise. */
export function InstrAvatar({ instr, size = 30 }: { instr: Partial<Instructor>; size?: number }) {
  if (instr.Photo) {
    return (
      <img
        src={instr.Photo}
        alt=""
        style={{ width: size, height: size, borderRadius: 99, objectFit: 'cover', flexShrink: 0, border: '1px solid var(--line)' }}
      />
    );
  }
  return (
    <span
      style={{
        width: size, height: size, borderRadius: 99, background: 'var(--brand-primary-l)',
        color: 'var(--brand-primary-d)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontWeight: 700, fontSize: size * 0.37, flexShrink: 0,
      }}
    >
      {instrInitials(instr)}
    </span>
  );
}
